export default __webpack_public_path__ + "images/0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9.png";